import {
  OUTSIDE_NETWORK,
  PLANNED,
  REPORTED,
  UNKNOWN,
  UNPLANNED,
} from "../../../components/OutageStatusType";
import {
  COMPLEX,
  MAJOR,
  MINOR,
  MODERATE,
} from "../../../components/PreliminaryEtrType";

const getUnplannedOutageStatusText = preliminaryEtrType => {
  switch (preliminaryEtrType) {
    case MINOR:
      return "Minor level outage";
    case MODERATE:
      return "Moderate level outage";
    case MAJOR:
      return "Major level outage";
    case COMPLEX:
      return "Complex level outage";
    default:
      return "Outage in your area";
  }
};

export const getOutageStatusText = (eventType, preliminaryEtrType) => {
  switch (eventType) {
    case REPORTED:
      return "An outage has been reported for this address";

    case OUTSIDE_NETWORK:
      return "Address not on the Vector network";

    case UNKNOWN:
      return "We're not aware of an outage here";

    case UNPLANNED:
      return getUnplannedOutageStatusText(preliminaryEtrType);

    case PLANNED:
      return "Planned work in your area";

    default:
      return "";
  }
};
